import React, { Component } from "react";
import Introduction from "./introduction";
import About from "./about";
import { Helmet } from "react-helmet";

class Home extends Component {
  render() {
    return (
      <div id="page">
        <Helmet>
          <meta charSet="utf-8" />
          <meta
            name="description"
            content="We specialize in Mobile, Windows, and Web application development using C#, ASP.NET, React, Flutter, SQL, JSON, and XML."
          />
          <title>Double The Fun</title>
        </Helmet>
        <div id="container-wrap">
          <Introduction></Introduction>
        </div>
      </div>
    );
  }
}

export default Home;
